import { render } from "./GiftcardGreetingAddon.vue?vue&type=template&id=d3e552be"
import script from "./GiftcardGreetingAddon.vue?vue&type=script&lang=js"
export * from "./GiftcardGreetingAddon.vue?vue&type=script&lang=js"

import "./GiftcardGreetingAddon.vue?vue&type=style&index=0&id=d3e552be&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__